import fetch from '../utils/fetch'

//模板列表
export const fetchTemplateList = (params) =>
  fetch(`capsule/template`, {
    params,
  })

//新增设备
export const fetchAddEquipment = (body) =>
  fetch(`capsule`, { method: 'post', body })

//设备列表
export const fetchEquipmentList = (params) =>
  fetch(`capsule/list`, {
    params,
  })

//编辑设备
export const fetchEditEquipment = (body) =>
  fetch(`capsule`, {
    method: 'put',
    body,
  })

//删除设备
export const fetchDeleteEquipment = (capsuleId) =>
  fetch(`capsule/${capsuleId}`, {
    method: 'delete',
  })

//更新微仓app（软件更新）
export const fetchUpdateSoftware = (data) =>
  fetch(`capsule/update`, {
    method: 'put',
    data,
  })

//获取微仓硬件版本信息
export const fetchHardwareVersionList = (data) =>
  fetch(`capsule/hardware/version`, {
    params: data,
  })

//更新微仓硬件
export const fetchUpdateHardware = (data) =>
  fetch(`capsule/hardware/update`, {
    method: 'put',
    data,
  })

//试试如意列表
export const fetchList = (data) => {
  return fetch(`/try/capsule/list`, {
    params: data,
  })
}

//添加
export const add = (data) => {
  return fetch(`/try/capsule`, {
    method: 'post',
    data,
  })
}

//编辑
export const edit = (data) => {
  return fetch(`/try/capsule`, {
    method: 'put',
    data,
  })
}
//删除试试如意设备
export const deleteTry = (data) => {
  return fetch(`/capsule/${data.id}`, {
    method: 'delete',
  })
}
//更新试试如意设备
export const updateTry = (data) => {
  return fetch(`/capsule/update`, {
    method: 'put',
    data,
  })
}
//查询可以绑定的设备列表
export const canBind = (data) => {
  return fetch(`/operate/capsule/list`, {
    params: data,
  })
}

//查询可以绑定的点位设备列表
export const canPointBind = (data) => {
  return fetch(`/operate/point/capsule/list`, {
    params: data,
  })
}
